import {
  GET_EXTRANET_NOTIFICATION,
  GET_EXTRANET_NOTIFICATION_SUCCESS,
  GET_EXTRANET_NOTIFICATION_FAILED,
  // READ_EXTRANET_NOTIFICATION,
  READ_EXTRANET_NOTIFICATION_SUCCESS,
  READ_EXTRANET_NOTIFICATION_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetExtranetNotification: false,
  extranetNotification: null,
};

export default function extranetNotification(state = initialState, action) {
  switch (action.type) {
    case GET_EXTRANET_NOTIFICATION:
      return {
        ...state,
        isLoadingGetExtranetNotification: true,
      };

    case GET_EXTRANET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoadingGetExtranetNotification: false,
        extranetNotification: action.payload,
      };

    case GET_EXTRANET_NOTIFICATION_FAILED:
      return {
        ...state,
        isLoadingGetExtranetNotification: false,
        extranetNotification: null,
      };

    case READ_EXTRANET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        extranetNotification: action.payload,
      };

    case READ_EXTRANET_NOTIFICATION_FAILED:
      return state;

    default:
      return state;
  }
}
